module.exports = __webpack_public_path__ + "img/mobile.c380a90d.svg";